import React from 'react'

import { Form } from '_zari/core'

import * as GlosasService from 'services/glosasContabilidad.service'

const GlosaFormGroup = ({ id, onIdChange, disabled, onBlur, oneRowTrigger, initialValue, ...props }) => {
  const [dataOptions, setDataOptions] = React.useState([])

  const lastSelectedId = React.useRef('')

  React.useEffect(() => {
    GlosasService.getSelectSinSocio().then(({ data }) => {
      setDataOptions(data)
      if (data && data.length === 1) {
        oneRowTrigger(data[0])
      } else if (data && data.length > 1 && initialValue) {
        const matchValue = data.find(x => x.nombre === initialValue)
        if (matchValue) {
          oneRowTrigger(matchValue)
        }
      }
    })
  }, [oneRowTrigger, initialValue])

  const innerOnBlur = React.useCallback(
    e => {
      const textValue = e.target.value

      const matchValue = dataOptions.find(x => x.nombre === textValue)
      if (matchValue) {
        if (lastSelectedId.current !== matchValue._id) {
          lastSelectedId.current = matchValue._id
          onIdChange(matchValue._id)
        }
      } else {
        lastSelectedId.current = ''
        onIdChange('')
      }

      if (onBlur) {
        onBlur(e)
      }
    },
    [dataOptions, onBlur, onIdChange]
  )

  return (
    <>
      <Form.InputText {...props} id={id} list={`datalist-${id}`} onBlur={innerOnBlur} disabled={disabled} />
      <datalist id={`datalist-${id}`} open='open'>
        {dataOptions.map((x, k) => (
          <option key={k} value={x.nombre} />
        ))}
      </datalist>
    </>
  )
}

export default React.memo(GlosaFormGroup)
